/**
 * B2B Business Categories for Google Maps Places API (New)
 *
 * IMPORTANT: All types are validated against Google Places API Table A
 *
 * Each category groups multiple Google Places API types together
 * Structure: { value: "unique_key", label: "Display Name", types: ["api_type1", "api_type2", ...] }
 */

export const B2B_CATEGORIES = [
	// Gastronomy & food
	{
		value: 'restaurants_all',
		label: 'Restaurants & Gastronomie (alle)',
		types: [
			'restaurant',
			'american_restaurant',
			'asian_restaurant',
			'barbecue_restaurant',
			'brazilian_restaurant',
			'breakfast_restaurant',
			'brunch_restaurant',
			'chinese_restaurant',
			'diner',
			'fast_food_restaurant',
			'fine_dining_restaurant',
			'french_restaurant',
			'greek_restaurant',
			'hamburger_restaurant',
			'indian_restaurant',
			'indonesian_restaurant',
			'italian_restaurant',
			'japanese_restaurant',
			'lebanese_restaurant',
			'mediterranean_restaurant',
			'mexican_restaurant',
			'middle_eastern_restaurant',
			'pizza_restaurant',
			'ramen_restaurant',
			'seafood_restaurant',
			'spanish_restaurant',
			'steak_house',
			'sushi_restaurant',
			'thai_restaurant',
			'turkish_restaurant',
			'vegan_restaurant',
			'vegetarian_restaurant',
			'vietnamese_restaurant',
			'buffet_restaurant',
			'dessert_restaurant',
		],
	},
	{
		value: 'cafes_bakeries',
		label: 'Cafés, Bäckereien & Konditoreien',
		types: ['cafe', 'bakery', 'coffee_shop', 'bagel_shop', 'donut_shop', 'tea_house'],
	},
	{
		value: 'bars_nightlife',
		label: 'Bars, Clubs & Nachtleben',
		types: ['bar', 'night_club', 'pub', 'wine_bar', 'bar_and_grill', 'karaoke'],
	},
	{
		value: 'food_delivery',
		label: 'Lieferdienste & Catering',
		types: ['meal_delivery', 'meal_takeaway', 'catering_service'],
	},
	{
		value: 'ice_cream_sweets',
		label: 'Eis, Süßwaren & Schokolade',
		types: [
			'ice_cream_shop',
			'candy_store',
			'chocolate_shop',
			'chocolate_factory',
			'confectionery',
			'dessert_shop',
		],
	},
	{
		value: 'specialty_food',
		label: 'Feinkost & Spezialitäten',
		types: ['deli', 'sandwich_shop', 'butcher_shop'],
	},

	// Retail
	{
		value: 'retail_fashion',
		label: 'Mode & Bekleidung',
		types: ['clothing_store', 'shoe_store', 'jewelry_store'],
	},
	{
		value: 'retail_electronics',
		label: 'Elektronik & Technik',
		types: ['electronics_store', 'cell_phone_store'],
	},
	{
		value: 'retail_home',
		label: 'Möbel & Einrichtung',
		types: ['furniture_store', 'home_goods_store', 'home_improvement_store'],
	},
	{
		value: 'retail_hardware',
		label: 'Baumärkte & Werkzeug',
		types: ['hardware_store', 'home_improvement_store'],
	},
	{
		value: 'retail_books',
		label: 'Buchhandlungen',
		types: ['book_store'],
	},
	{
		value: 'retail_sporting',
		label: 'Sportartikel & Outdoor',
		types: ['sporting_goods_store', 'bicycle_store'],
	},
	{
		value: 'retail_gifts',
		label: 'Geschenkartikel & Blumen',
		types: ['gift_shop'],
	},
	{
		value: 'retail_pets',
		label: 'Tierbedarfshandel',
		types: ['pet_store'],
	},
	{
		value: 'retail_supermarket',
		label: 'Supermärkte & Lebensmittelhandel',
		types: ['supermarket', 'grocery_store', 'convenience_store', 'market', 'asian_grocery_store', 'food_store'],
	},
	{
		value: 'retail_liquor',
		label: 'Getränkehandel',
		types: ['liquor_store'],
	},
	{
		value: 'retail_wholesale',
		label: 'Großhandel',
		types: ['wholesaler', 'warehouse_store'],
	},
	{
		value: 'retail_shopping_centers',
		label: 'Einkaufszentren & Warenhäuser',
		types: ['shopping_mall', 'department_store', 'discount_store'],
	},
	{
		value: 'retail_general',
		label: 'Einzelhandel (allgemein)',
		types: ['store'],
	},

	// Automotive
	{
		value: 'auto_dealers',
		label: 'Autohändler & Fahrzeugverkauf',
		types: ['car_dealer'],
	},
	{
		value: 'auto_repair',
		label: 'Autowerkstätten & Reparatur',
		types: ['car_repair'],
	},
	{
		value: 'auto_parts',
		label: 'Autoteile & Zubehör',
		types: ['auto_parts_store'],
	},
	{
		value: 'auto_services',
		label: 'Autowäsche & Pflege',
		types: ['car_wash'],
	},
	{
		value: 'auto_rental',
		label: 'Autovermietung',
		types: ['car_rental'],
	},
	{
		value: 'gas_stations',
		label: 'Tankstellen',
		types: ['gas_station', 'electric_vehicle_charging_station'],
	},

	// Healthcare
	{
		value: 'health_doctors',
		label: 'Ärzte & Arztpraxen',
		types: ['doctor'],
	},
	{
		value: 'health_dentists',
		label: 'Zahnärzte',
		types: ['dentist', 'dental_clinic'],
	},
	{
		value: 'health_hospitals',
		label: 'Krankenhäuser & Kliniken',
		types: ['hospital', 'medical_lab'],
	},
	{
		value: 'health_pharmacy',
		label: 'Apotheken',
		types: ['pharmacy', 'drugstore'],
	},
	{
		value: 'health_therapy',
		label: 'Therapeuten & Physiotherapie',
		types: ['physiotherapist', 'chiropractor'],
	},
	{
		value: 'health_alternative',
		label: 'Alternative Medizin & Wellness',
		types: ['wellness_center', 'skin_care_clinic'],
	},
	{
		value: 'health_veterinary',
		label: 'Tierärzte',
		types: ['veterinary_care'],
	},

	// Beauty & wellness
	{
		value: 'beauty_hair',
		label: 'Friseure & Barbershops',
		types: ['barber_shop', 'beautician'],
	},
	{
		value: 'beauty_salons',
		label: 'Kosmetikstudios',
		types: ['beauty_salon'],
	},
	{
		value: 'beauty_spa',
		label: 'Wellness, Spa & Massage',
		types: ['spa', 'massage', 'sauna'],
	},
	{
		value: 'beauty_fitness',
		label: 'Fitnessstudios & Gyms',
		types: ['gym', 'fitness_center'],
	},
	{
		value: 'beauty_yoga',
		label: 'Yoga & Pilates',
		types: ['yoga_studio'],
	},
	{
		value: 'beauty_tanning',
		label: 'Sonnenstudios',
		types: ['tanning_studio'],
	},
	{
		value: 'beauty_tattoo',
		label: 'Tattoo & Piercing',
		types: ['body_art_service'],
	},

	// Professional services
	{
		value: 'professional_accounting',
		label: 'Steuerberater & Wirtschaftsprüfer',
		types: ['accounting'],
	},
	{
		value: 'professional_consulting',
		label: 'Unternehmensberatung',
		types: ['consultant'],
	},
	{
		value: 'professional_office',
		label: 'Büros & Unternehmen',
		types: ['corporate_office'],
	},

	// Trades & services
	{
		value: 'services_cleaning',
		label: 'Reinigungsdienste',
		types: [],
	},

	// Accommodation & tourism
	{
		value: 'lodging_hotels',
		label: 'Hotels & Motels',
		types: ['hotel', 'resort_hotel', 'extended_stay_hotel', 'motel'],
	},
	{
		value: 'lodging_alternative',
		label: 'Alternative Unterkünfte',
		types: ['bed_and_breakfast', 'guest_house', 'hostel', 'inn', 'cottage'],
	},
	{
		value: 'lodging_camping',
		label: 'Camping & Wohnmobilstellplätze',
		types: ['campground', 'rv_park', 'camping_cabin'],
	},
	{
		value: 'lodging_general',
		label: 'Unterkünfte (allgemein)',
		types: ['lodging'],
	},
	{
		value: 'tourism_travel',
		label: 'Reisebüros',
		types: ['travel_agency', 'tour_agency'],
	},

	// Education
	{
		value: 'education_schools',
		label: 'Schulen',
		types: ['school', 'primary_school', 'secondary_school'],
	},
	{
		value: 'education_university',
		label: 'Universitäten & Hochschulen',
		types: ['university'],
	},
	{
		value: 'education_preschool',
		label: 'Kindergärten & Kitas',
		types: ['preschool', 'child_care_agency'],
	},
	{
		value: 'education_library',
		label: 'Bibliotheken',
		types: ['library'],
	},

	// Finance
	{
		value: 'finance_banks',
		label: 'Banken & Sparkassen',
		types: ['bank'],
	},

	// Office & business
	{
		value: 'business_courier',
		label: 'Versand & Logistik',
		types: ['courier_service'],
	},

	// Entertainment & events
	{
		value: 'entertainment_cinema',
		label: 'Kinos',
		types: ['movie_theater'],
	},
	{
		value: 'entertainment_venues',
		label: 'Event-Locations & Veranstaltungsräume',
		types: ['event_venue', 'banquet_hall', 'convention_center', 'wedding_venue'],
	},
	{
		value: 'entertainment_arts',
		label: 'Theater & Konzerthallen',
		types: ['performing_arts_theater', 'concert_hall', 'amphitheatre', 'opera_house'],
	},
	{
		value: 'entertainment_museums',
		label: 'Museen & Galerien',
		types: ['museum', 'art_gallery'],
	},
	{
		value: 'entertainment_bowling',
		label: 'Bowling & Spielhallen',
		types: ['bowling_alley', 'video_arcade'],
	},
	{
		value: 'entertainment_casino',
		label: 'Casinos & Spielhallen',
		types: ['casino'],
	},
	{
		value: 'entertainment_comedy',
		label: 'Comedy & Unterhaltung',
		types: ['comedy_club'],
	},

	// Sports & leisure
	{
		value: 'sports_facilities',
		label: 'Sportstätten & Stadien',
		types: ['sports_complex', 'stadium', 'sports_club', 'arena', 'athletic_field'],
	},
	{
		value: 'sports_golf',
		label: 'Golfplätze',
		types: ['golf_course'],
	},
	{
		value: 'sports_swimming',
		label: 'Schwimmbäder',
		types: ['swimming_pool', 'public_bath'],
	},
	{
		value: 'sports_skiing',
		label: 'Ski & Wintersport',
		types: ['ski_resort', 'ice_skating_rink'],
	},
	{
		value: 'sports_other',
		label: 'Sonstige Sportanlagen',
		types: ['playground', 'skateboard_park'],
	},

	// Public institutions
	{
		value: 'public_government',
		label: 'Behörden & Ämter',
		types: ['local_government_office', 'city_hall', 'courthouse', 'government_office'],
	},
	{
		value: 'public_post',
		label: 'Post',
		types: ['post_office'],
	},

	// Transport
	{
		value: 'transport_airport',
		label: 'Flughäfen',
		types: ['airport', 'international_airport'],
	},
	{
		value: 'transport_train',
		label: 'Bahnhöfe',
		types: ['train_station', 'subway_station', 'light_rail_station', 'transit_station'],
	},
	{
		value: 'transport_bus',
		label: 'Bushaltestellen & Busbahnhöfe',
		types: ['bus_station', 'bus_stop'],
	},
];

// Sort categories alphabetically by label
const SORTED_B2B_CATEGORIES = [...B2B_CATEGORIES].sort((a, b) => a.label.localeCompare(b.label, 'de'));

export default SORTED_B2B_CATEGORIES;
